import { render } from "./StrategyHeader.vue?vue&type=template&id=24c2ddaf&scoped=true&ts=true"
import script from "./StrategyHeader.vue?vue&type=script&lang=ts"
export * from "./StrategyHeader.vue?vue&type=script&lang=ts"

import "./StrategyHeader.vue?vue&type=style&index=0&id=24c2ddaf&scoped=true&lang=less"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c2ddaf"]])

export default __exports__